import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user';
import { Email } from './email';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class UserService {
	baseUrl = environment.baseUrl;
  private usersUrl = this.baseUrl +'/api/users';  // URL to web api
   private EmailUrl = this.baseUrl +'/api/users/sendemail';  // URL to web api
  private getuserlistByRolePoapproverUrl = this.baseUrl + '/api/users/getuserlistByRolePoapprover';  // URL to web api
  private getuserlistByRolePoapproverLevel2Url = this.baseUrl + '/api/users/getuserlistByRolePoapproverLevel1';  // URL to web api
  private getuserlistByRolePoreviewerUrl = this.baseUrl + '/api/users/getuserlistByRolePoreviewer';  // URL to web api
  
  constructor( 
    private http: HttpClient
  ) { }
 
  getUsers (): Observable<User[]> {
    return this.http.get<User[]>(this.usersUrl)
  }
 
  getUser(userid: number): Observable<User> {
    const url = `${this.usersUrl}/${userid}`;
    return this.http.get<User>(url);
  }
  
  ResetPassword(userid: number): Observable<User> {
    const url = `${this.usersUrl}/resetpasssword/${userid}`;
    return this.http.get<User>(url);
  }


  getUserByroleByApprover(): Observable<User[]> {
    return this.http.get<User[]>(this.getuserlistByRolePoapproverUrl)
  }

  getUserByroleByApproverLevel2(): Observable<User[]> {
    return this.http.get<User[]>(this.getuserlistByRolePoapproverLevel2Url)
  }
  getUserByroleByReviewer(): Observable<User[]> {
    return this.http.get<User[]>(this.getuserlistByRolePoreviewerUrl)
  }
  
    getUserinfo(): Observable<User> {
    const url = `${this.usersUrl}/userinfo`;
    return this.http.get<User>(url);
  }
  
   SendEmail (email: Email): Observable<Email> {
    return this.http.post<Email>(this.EmailUrl, email, httpOptions);
  }
   Changepassword (user: User): Observable<User> {
	     const url = `${this.usersUrl}/changepassword`;
    return this.http.post<User>(url, user, httpOptions);
  }
 
  addUser (user: User): Observable<User> {
    return this.http.post<User>(this.usersUrl, user, httpOptions);
  }
 
  deleteUser (user: User | number): Observable<User> {
    const id = typeof user === 'number' ? user : user.userid;
    const url = `${this.usersUrl}/${id}`;
 
    return this.http.delete<User>(url, httpOptions);
  }
 
  updateUser (user: User): Observable<any> {
    return this.http.put(this.usersUrl, user, httpOptions);
  }

  getdepartment (): Observable<User[]> {
    return this.http.get<User[]>( this.baseUrl +'/api/department')
  }
  getuserrole (): Observable<User[]> {
    return this.http.get<User[]>( this.baseUrl +'/api/userRoles')
  }

}